/**
 * Convert the CH24 UK price (GBP) into another Chrono24 account's currency,
 * using a useAllFx("GBP") table.
 *
 * DIRECTION: useAllFx(target) / GET /api/fx/all/{target} returns
 * rates[CODE] = value of ONE unit of CODE in the target (CurrencyConverterService
 * ::getRates loads each row with from=CODE, to=target). So with target GBP,
 * rates.EUR ≈ 0.86 (1 EUR = 0.86 GBP) and rates.HKD ≈ 0.10.
 * Going GBP → CODE therefore DIVIDES by rates[CODE]:
 *   £10,000 / 0.86 ≈ €11,628   (multiplying gave €8,600 — 26% too low)
 *
 * Returns a whole-number price, or null when the rate is missing / unusable
 * (the caller then leaves the field alone rather than writing a guess).
 */
export const gbpToAccountPrice = (gbpPrice, rates, currency) => {
  const price = Number(gbpPrice);
  if (!Number.isFinite(price) || price <= 0 || !currency) return null;
  // The API may send the rate as a numeric string (currency_rates.rate is not cast).
  const rate = Number(rates?.[String(currency).toUpperCase()]);
  if (!Number.isFinite(rate) || rate <= 0) return null;
  return Math.round(price / rate);
};
